import React from 'react';
import PropTypes from 'prop-types';

// styles
import './styles.scss';

// proptypes & context
const propTypes = {
  url: PropTypes.string.isRequired,
  goto: PropTypes.string.isRequired,
};

const contextTypes = {
  t: PropTypes.func,
};

function NewsletterForm({ url, goto }, { t }) {
  return (
    <form
      action={url}
      acceptCharset="UTF-8"
      name="oi_form"
      className="newsletter__form"
      method="get"
    >
      <div className="newsletter__input field">
        <label htmlFor="email">
          <span className="field__label">{t('form.newsletter.email')}</span>
          <input
            name="email"
            className="field__input"
            type="text"
            placeholder="adresse@courriel.com"
          />
        </label>
      </div>
      <input type="hidden" name="iehack" value="&#9760;" />
      <input type="hidden" name="goto" value={goto} />
      <input
        type="submit"
        value={t('form.newsletter.submit')}
        className="newsletter__button button  button--border-light"
      />
    </form>
  );
}

NewsletterForm.propTypes = propTypes;
NewsletterForm.contextTypes = contextTypes;

export default NewsletterForm;



// WEBPACK FOOTER //
// ./src/app/components/layouts/newsletter/NewsletterForm.js